import React, {ReactElement} from 'react';

import './MultiColumns.scss';

export enum MultiColumnsVariant {
  TWO_COL_MAX = 'twoColMax',
  THREE_COL_MAX = 'threeColMax',
}

export enum MultiColumnsPlacing {
  HORIZONTAL = 'placeHorizontal',
  VERTICAL = 'placeVertical',
}

interface MultiColumnsProps<TData> {
  className?: string;
  data: TData[];
  template: (datum: TData) => ReactElement;
  variant?: MultiColumnsVariant;
  placing?: MultiColumnsPlacing;
}

function MultiColumns<TData extends Record<string, unknown> = Record<string, unknown>>({
  className = '',
  data,
  template,
  variant = MultiColumnsVariant.THREE_COL_MAX,
  placing = MultiColumnsPlacing.VERTICAL,
}: MultiColumnsProps<TData>): ReactElement {
  return (
    <div className={`multiColumns multiColumns--${variant} multiColumns--${placing} ${className}`.trim()}>
      {data.map((datum, i) => (
        // @todo: specify data with key so list can be dynamic
        <div key={i.toString()} className="multiColumns__col">
          {template(datum)}
        </div>
      ))}
    </div>
  );
}

export default MultiColumns;
